
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAdmin } from '@/hooks/use-admin';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export function AdminProtectedRoute({ children }: AdminProtectedRouteProps) {
  const location = useLocation();
  const { isAdmin, loading, error } = useAdmin();

  // Show loading state while checking admin status
  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // If not an admin, redirect to admin login while preserving the attempted URL
  if (!isAdmin) {
    return <Navigate to="/admin-signin" state={{ from: location }} replace />;
  }

  // If authenticated as admin, render children
  return <>{children}</>;
}
